// DOC REF {reportProgress: true, observe: "events"}
// https://blog.devgenius.io/file-upload-with-progress-bar-in-angular-13-76adb3380f18
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Answer } from '@models/answer/Answer';
import { Response } from '@models/response-api/ResponseApi';

@Injectable({
	providedIn: 'root',
})
export class AnswerService {
	private url = `${environment.hostAPI}/answers`;

  constructor(private http: HttpClient) {}

  save(answer: Answer) {
    return this.http.post<Response>(this.url, answer);
  }

  update(answer: Answer) {
    return this.http.put<Response>(this.url, answer);
  }

  remove(answer: Answer) {
    const url = `${this.url}?id=${answer.id}`;
    return this.http.delete<Response>(url);
  }
}
